import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {Link} from "react-router-dom";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { countriesAction } from "../../actions/commonActions";
import { createSeller, clearSellerMsg } from "../../actions/sellerAction";


const SellerCreate = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [error, setError] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [isOverPriceChecked, setIsOverPriceChecked] = useState(false);


    const [sellerDetails, setSellerDetails] = useState({
        id:"", seller_name: "", email: "", address: "", commission: "", city: "", country: "", phone_no: ""
    });

    // useEffect for call Api's
    useEffect(() => {
        dispatch(countriesAction());
    }, [dispatch]);

    // get the countries list from reducer and set here
    const countriesList = useSelector((state) => state.countries.countries)
    useEffect(() => {
        if (countriesList && countriesList?.data && countriesList?.data?.status === true) {
            setCountryList(countriesList?.data?.data);
        }
    }, [countriesList]);

    // Update the state when we change the value
    const handleSellerFormDetails = (e) => {
        // Check if the input value is a valid number with at most 5 digits
        if (e.target.name === 'commission' && !/^\d{0,5}(\.\d{0,2})?$/.test(e.target.value)) {
            return;
        }
        // Validate phone_no input against regex pattern
        if (e.target.name === 'phone_no' && !/^[0-9\-()+ ]{0,15}$/.test(e.target.value)) {
            return;
        }
        setSellerDetails({
            ...sellerDetails, 
            [e.target.name]: e.target.value
        })
    }

    const handleOverPrice = (e) => {
        setIsOverPriceChecked(!isOverPriceChecked);
    }

    // function to create seller
    const sellerSubmit = async (e) => {
        e.preventDefault();
        if (!sellerDetails.seller_name) {
            setError(true);
            return false;
        } else {
            dispatch(
                createSeller({
                    name    : sellerDetails?.seller_name,
                    email   : sellerDetails?.email,
                    address : sellerDetails?.address,
                    commission : sellerDetails?.commission,
                    over_price  : isOverPriceChecked,
                    city    : sellerDetails?.city,
                    country : sellerDetails?.country,
                    phone_no: sellerDetails?.phone_no,
                })
            );
        }
    };

    //select data from reducer and set toaster here
    const createSellerDtl = useSelector((state) => state.createSeller.createSeller)
    useEffect(() => {
        if (createSellerDtl && createSellerDtl?.data && createSellerDtl?.data?.status === true) {
            toast.success(createSellerDtl?.data?.message,{theme: "dark",});
            dispatch(clearSellerMsg());
            if((props?.from) && props?.from === 'salesOrder'){
                props.onReturn(createSellerDtl?.data);
            }else{
                navigate("/sellers")
            }
        }
        if (createSellerDtl && createSellerDtl?.data && createSellerDtl?.data?.status === false) {
            toast.error(createSellerDtl?.data?.message,{theme: "dark",});
        }
    }, [createSellerDtl,navigate,dispatch,props]);

    return (
        <>
            <div className="dash-body">
                <div className="head-row">
                    <h3>Add Seller</h3>
                </div>
                <form onSubmit={sellerSubmit}>
                    <div className="box-body box-shd">
                        <div className="row">
                            <div className="col-sm-6 col-lg-4 dash-form-col">
                                <label>Seller Name<span className="text-danger">*</span></label>
                                <input className="form-control" type="text" id="seller_name" name="seller_name"
                                    value={sellerDetails.seller_name}
                                    onChange={handleSellerFormDetails}
                                    placeholder="Enter Seller Name"
                                    maxLength="255"
                                    />
                                {error && !sellerDetails?.seller_name && (
                                    <span style={{ color: "red" }} className="invalidInput" >
                                        Required*
                                    </span>
                                )}
                            </div>
                            <div className="col-sm-6 col-lg-4 dash-form-col">
                                <label>Phone No.</label>
                                <input className="form-control" type="text"
                                    value={sellerDetails.phone_no || ''}
                                    onChange={handleSellerFormDetails}
                                    name="phone_no"
                                    placeholder="Enter No."
                                />
                            </div>
                            <div className="col-sm-6 col-lg-4 dash-form-col">
                                <label>Address</label>
                                <input className="form-control" type="text" id="address" name="address"
                                    value={sellerDetails.address || ''}
                                    onChange={handleSellerFormDetails}
                                    placeholder="Enter Address" 
                                    maxLength="255"
                                />
                            </div>
                            <div className="col-sm-6 col-lg-4 dash-form-col">
                                <label>Email</label>
                                <input className="form-control" type="email"
                                    value={sellerDetails.email || ''}
                                    onChange={handleSellerFormDetails}
                                    name="email"
                                    placeholder="Enter Email"
                                    maxLength="255"
                                />
                            </div>
                            <div className="col-sm-6 col-lg-4 dash-form-col">
                                <label>Country</label>
                                <select className="form-control" name="country" onChange={handleSellerFormDetails} value={sellerDetails.country || ''}>
                                    <option value="">--Select country--</option>
                                    {countryList.map((data,i) => (
                                        <option key={i} value={data.name}>{data.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-sm-6 col-lg-4 dash-form-col">
                                <label>City</label>
                                <input className="form-control"
                                    placeholder="Enter City"
                                    name="city"
                                    value={sellerDetails.city || ''}
                                    onChange={handleSellerFormDetails}
                                    maxLength="255"
                                />
                            </div>
                            <div className="col-sm-6 col-lg-4 dash-form-col">
                                <label>Commission %</label>
                                <input className="form-control" type="number" step="0.01" id="commission" name="commission"
                                    value={sellerDetails.commission || ''}
                                    onChange={handleSellerFormDetails}
                                    placeholder="Enter Commission" 
                                    min="0"
                                />
                            </div>
                            <div className="col-sm-6 col-lg-4 dash-form-col">
                                <label>&nbsp;</label>
                                <div className="form-check">
                                    {/* <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/> */}
                                    <input
                                        name="over_price"
                                        className="form-check-input"
                                        type="checkbox"
                                        id="inlineCheckbox1"
                                        value={1}  // Set the value to "1"
                                        checked={isOverPriceChecked}
                                        onChange={(e) => handleOverPrice(e)}
                                    />
                                    <label className="form-check-label" htmlFor="inlineCheckbox1">Over Price</label>
                                </div>
                            </div>

                            <div className="dash-btn-group mt-2">
                                <button type="submit" className="cus-btn">Save</button>
                                {((props?.from) && props?.from === 'salesOrder') ? "" :
                                <Link to="/sellers"><button className="cus-btn">Cancel</button></Link>}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default SellerCreate;
